import axiosInstance from "../../../axios";
import config from "../../../config";

export const createNewTicketSlice = (set, get) => ({
    newTicket: {
        loading: false,
        data: []
    },
    postNewTicket: async (params) => {
        const token = get().business.currentBusiness.token;
        set(state => ({ newTicket: { ...state.newTicket, loading: true } }));
        try {
            const res = await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `/v1/business/ticket-with-attachments`,
                data: params,
                headers: { token }
            });
            set(state => ({ newTicket: { loading: false, data: res.data } }));
            // Additional actions like notifying success and toggling modal would go here
        } catch (error) {
            set(state => ({ newTicket: { ...state.newTicket, loading: false } }));
        }
    }
});
